export const globalMixin = {
    methods: {
        capitalizeWords(name) {
            return name
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        },
        validateField(type = 'text', content = '', maxl = 10, minl= 0) {
            // Eliminar espacios en blanco al inicio y al final del contenido
            const trimmedContent = content.trim();
      
            // Verificar la longitud del contenido
            if (trimmedContent.length < minl) {
              return false;
            }
            if (trimmedContent.length > maxl) {
                return false;
              }

              
      
            // Definir expresiones regulares para cada tipo de validación
            const regexPatterns = {
              number: /^[0-9]+$/, // Solo números
              text: /^[a-zA-Z\sáéíóúÁÉÍÓÚñÑüÜ]+$/, // Solo letras
              comment: /^[a-zA-Z0-9\s.,;:!?()áéíóúÁÉÍÓÚñÑüÜ-]+$/ // Texto permitido en comentarios
            };
      
            // Seleccionar la expresión regular según el tipo
            const regex = regexPatterns[type];
      
            // Si no hay una expresión regular definida para el tipo, retornar false
            if (!regex) {
              return false;
            }
      
            // Validar el contenido según la expresión regular correspondiente
            return regex.test(trimmedContent);
        },
        pasteFilterNumber(event) {
            event.preventDefault();
            let nextCodecode = event.clipboardData.getData('text').replace(/\D+/g, '');
            nextCodecode = nextCodecode.slice(0, 10);
            event.target.value = nextCodecode;
            event.target.dispatchEvent(new Event('input', { bubbles: true }));
        },
        pasteFilterLetter(event) {
            event.preventDefault();
            let pastedText = event.clipboardData.getData('text');
            let filteredText = pastedText.replace(/[^a-zA-Z]+/g, '');
            event.target.value = filteredText;
            event.target.dispatchEvent(new Event('input', { bubbles: true }));
        },
        pasteFilterComment(event) {
            event.preventDefault();
            const pastedText = event.clipboardData.getData('text');
      
            // Expresión regular que permite letras, números, espacios y signos de puntuación comunes
            const allowedCharacters = /[a-zA-Z0-9\s.,;:!?()'"áéíóúÁÉÍÓÚñÑüÜ-]/g;
      
            // Filtrar el texto pegado
            const filteredText = pastedText.match(allowedCharacters)?.join('') || '';
      
            // Insertar el texto filtrado en la posición actual del cursor
            const input = event.target;
            const start = input.selectionStart;
            const end = input.selectionEnd;
            const textBefore = input.value.substring(0, start);
            const textAfter = input.value.substring(end);
            input.value = textBefore + filteredText + textAfter;
      
            // Colocar el cursor al final del texto pegado
            const newCursorPosition = start + filteredText.length;
            input.setSelectionRange(newCursorPosition, newCursorPosition);
            event.target.dispatchEvent(new Event('input', { bubbles: true }));
        },
        disableCopy(event) {
            event.preventDefault();
        },
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        cleanInput(input) {
            const cleanedValue = input.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
    
            if (input.value !== cleanedValue) {
                input.value = cleanedValue;
                input.dispatchEvent(new Event('input')); // Dispara el evento input si hay cambios
            }
        },
        cleanInputNumber(input){
            const cleanedValue = input.value.replace(/[^0-9]/g, '');
    
            if (input.value !== cleanedValue) {
                input.value = cleanedValue;
                input.dispatchEvent(new Event('input')); // Dispara el evento input si hay cambios
            }
        },
        cleanInputComment(input) {
            const cleanedValue = input.value.replace(/[^a-zA-Z0-9\s.,;:!?()'"áéíóúÁÉÍÓÚñÑüÜ-]/g, '');
            if (input.value !== cleanedValue) {
                input.value = cleanedValue;
                input.dispatchEvent(new Event('input'));
            }
        },
        onlyLetters(e) {

            const key = e.key;
            const isLetterOrSpace = key.match(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/u);
            const isControlKey = e.ctrlKey || e.metaKey || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Shift'].includes(key);
            // Si la tecla no es una letra, un espacio o una tecla de control, prevenir la acción por defecto
            if (!isLetterOrSpace && !isControlKey) {
                e.preventDefault();
            }
            this.cleanInput(e.target);
        },
        onlyComment(event) {
            const key = event.key;
            const keyCode = event.keyCode || event.which;
        
            // Expresión regular que permite letras, números, espacios y signos de puntuación comunes
            const allowedCharacters = /^[a-zA-Z0-9\s.,;:!?()'"áéíóúÁÉÍÓÚñÑüÜ-]$/;
        
            // Teclas de control permitidas (Backspace, Delete, flechas, Tab, Shift, etc.)
            const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Shift'];
        
            // Verificar si la tecla es permitida
            if (!allowedCharacters.test(key) && !controlKeys.includes(key)) {
                event.preventDefault();
            }
        
            this.cleanInputComment(event.target);
        },

        cash(value){
            if (isNaN(value)) {
                return value;
            }
            value = parseFloat(value).toFixed(2);
            var formatter =  '$ '+value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            return formatter
        },

        onlyNumbers(e){
            const key = e.key;
            const numbers = key.match(/[0-9]$/u);

            const isControlKey = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key);
    
            // Si no es una tecla de control y no es Ctrl+V
            if (!isControlKey && !e.ctrlKey) {
                if(numbers == null){
                    e.preventDefault();
                }
            }
        
            // Si es Ctrl+V, permitir pegar
            if (e.ctrlKey && key !== 'v') {
                e.preventDefault();
            }
            this.cleanInputNumber(e.target);
        },
    },
};